import { theme } from '@westwing/ui-kit/Theme';
import { css } from 'styled-components';

export type ThemeInterface = typeof theme;

export type Color = keyof typeof theme.colors;

export default theme;

// This breakpoint is only needed and used in one place (Back to top button on LLP)
// Its a special situation breakpoint and can live within bella not the ui-kit
export const llpBackToTopBreakpoint = (...args: Parameters<typeof css>) => css`
    @media all and (min-width: 1560px) {
        ${css(...args)}
    }
`;

export const paddedMaxScreenWidth = `${1440 + 80}px`; // 1440px(max screen width) + 80px (40px padding on either sides)
